import { render, staticRenderFns } from "./EnvironmentPill.vue?vue&type=template&id=570836e4&scoped=true"
import script from "./EnvironmentPill.vue?vue&type=script&lang=js"
export * from "./EnvironmentPill.vue?vue&type=script&lang=js"
import style0 from "./EnvironmentPill.vue?vue&type=style&index=0&id=570836e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570836e4",
  null
  
)

export default component.exports